import React from 'react'
import Course from './Course'
import HeroSection from './HeroSection'
import ServiceSection from './ServiceSection'
import { Helmet } from 'react-helmet';

const Home = () => {
    return (
        <>
            <Helmet>
                <title>Best Study Abroad Consultancy in Kerala | Vidyaportal</title>
                <meta name="description" content="Looking for the best abroad study consultancy in Kerala? Vidyaportal offers expert guidance, visa support, and top university admissions." />
                <meta name="keywords" content="best abroad study consultancy in Kerala, best study abroad consultancy in Kerala, study abroad Kerala, overseas education Kerala" />
                <link rel="canonical" href="https://vidyaportal.com/" />
            </Helmet>

            <main>
                <HeroSection />
                <ServiceSection />
                <Course />
            </main >
        </>

    )
}

export default Home